import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() public message: string = '';
  @Input() public type: 'info' | 'warning' | 'error' | 'success' = 'info';
  @Input() public displayIcon = true;
  @Output() public close: EventEmitter<void> = new EventEmitter();
  public faTimes = faTimes;
}
